var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGeanderterStatusYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4389",
    "data-name": "Group 4389",
    transform: "translate(-6286 -6700)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108",
    "data-name": "Ellipse 108",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(6286 6700)",
    fill: "#e8fcff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "download",
    transform: "translate(6310.997 6725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    d: "M397.207,389.52l-7.71,7.71,6.539,6.539,7.71-7.71Zm2.719,8.758-1.672,1.671a.806.806,0,0,1-1.139,0l-1.671-1.671c-.018-.018-.035-.037-.05-.056s-.02-.015-.029-.024l-1.212-1.211a1.987,1.987,0,1,1,2.81-2.811l1.082,1.082h0a.515.515,0,0,1,.077.1.808.808,0,0,1,.132.106l1.671,1.671h0a.806.806,0,0,1,0,1.139Z",
    transform: "translate(-363.005 -363.028)",
    fill: "#00c4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    d: "M321.82,323.212l1.368-1.367,1.368,1.367-1.368,1.368Z",
    transform: "translate(-302.795 -302.82)",
    fill: "#00c4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    d: "M271.568,263.89a1.481,1.481,0,0,0-2.09,0l-5.621,5.621h0a1.477,1.477,0,0,0,0,2.089l5.495,5.495,7.71-7.71Zm.237,9.619h0a.806.806,0,0,1-1.14,0l-1.671-1.671h0a.805.805,0,0,1,0-1.14l1.519-1.52-.722-.721h0a.967.967,0,0,0-1.367,1.367.51.51,0,1,1-.722.721,1.988,1.988,0,1,1,2.81-2.811l1.082,1.082a.513.513,0,0,1,.078.1.823.823,0,0,1,.131.106l1.671,1.671a.805.805,0,0,1,0,1.14Z",
    transform: "translate(-250.843 -250.876)",
    fill: "#00c4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    d: "M381.239,410.7a.086.086,0,0,0,.122.122.086.086,0,0,0-.122-.122Z",
    transform: "translate(-355.636 -381.846)",
    fill: "#00c4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    d: "M437.39,436.044a.967.967,0,0,0-1.367,1.367l.721.721,1.368-1.368Z",
    transform: "translate(-404.153 -404.174)",
    fill: "#00c4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    d: "M451.31,452.7l1.368-1.367,1.368,1.367-1.368,1.368Z",
    transform: "translate(-417.998 -418.023)",
    fill: "#00c4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    d: "M331.4,323.71l-7.71,7.71,6.539,6.539,7.71-7.71Zm2.751,7.216a1.1,1.1,0,0,1-1.044.291l-1.911,1.911a1.1,1.1,0,0,1-1.074,1.368,1.094,1.094,0,0,1-.262-.032l-.546.546a.51.51,0,0,1-.722,0l-.6-.6h0a1.354,1.354,0,0,1-.06-1.845l.282-.321,0-.6a3.531,3.531,0,0,1,1.027-2.5l.309-.309a3.525,3.525,0,0,1,2.05-1,1.428,1.428,0,0,1,.131-1.322.51.51,0,0,1,.852.561.41.41,0,0,0-.02.416l0,0a1.04,1.04,0,0,1,1.448.021l.786.786a.872.872,0,0,1,0,1.231l-.354.354h0a1.1,1.1,0,0,1-.29,1.043Z",
    transform: "translate(-304.456 -304.479)",
    fill: "#00c4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    d: "M410.718,381.25a.081.081,0,0,0-.06.025.085.085,0,1,0,.12.12.086.086,0,0,0,0-.12A.084.084,0,0,0,410.718,381.25Z",
    transform: "translate(-381.808 -355.67)",
    fill: "#00c4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M373.017,364.658l-.467.468c-.01.009-.02.018-.029.026l-.011.01a.469.469,0,0,1-.075.05l-.007,0-.01,0-.032.015-.025.01-.031.009-.027.007-.031.006-.029,0-.031,0h-.028a.459.459,0,0,1-.055,0h-.009a2.5,2.5,0,0,0-2.1.706l-.309.309a2.5,2.5,0,0,0-.728,1.775l.005.8h0a.511.511,0,0,1-.127.34l-.409.467h0a.33.33,0,0,0,.015.45l.238.238.138-.138h0a1.105,1.105,0,0,1,1.431-1.431l1.815-1.815a1.106,1.106,0,0,1,1.432-1.432l.2-.2-.681-.681h0a.019.019,0,0,0-.027,0Z",
    transform: "translate(-344.213 -340.904)",
    fill: "#00c4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    d: "M186.207,180.171a.51.51,0,0,0,0-1.021,7.073,7.073,0,0,0-7.066,7.066.51.51,0,1,0,1.02,0,6.052,6.052,0,0,1,6.045-6.045Z",
    transform: "translate(-175.858 -175.869)",
    fill: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M159.733,150.431a.51.51,0,0,0,0-1.021,10.352,10.352,0,0,0-10.348,10.348.51.51,0,0,0,1.021,0,9.331,9.331,0,0,1,9.327-9.327Z",
    transform: "translate(-149.385 -149.41)",
    fill: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    d: "M463.132,455.48l-7.676,7.676a5.452,5.452,0,0,0,7.676-7.676Z",
    transform: "translate(-421.686 -421.71)",
    fill: "#00c4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    d: "M211.543,194a5.453,5.453,0,0,0-7.71,0l-3.884,3.883a1.5,1.5,0,0,0-2.071,2.071L194,203.835a5.458,5.458,0,0,0,0,7.71l22.485,22.485a12.408,12.408,0,0,0,17.548-17.548Zm13.36,37.38a6.429,6.429,0,0,1-4.577-1.9L199.95,209.1a2.5,2.5,0,0,1,0-3.532l5.621-5.621h0a2.5,2.5,0,0,1,3.532,0l20.377,20.377a6.473,6.473,0,0,1-4.577,11.049Zm5.2,2.238-.016.016h0a.51.51,0,1,1-.721-.721l.017-.016h0a.51.51,0,1,1,.722.721Zm3.513-3.513-2.1,2.1h0a.51.51,0,0,1-.722-.721l2.1-2.1a.51.51,0,1,1,.721.721Z",
    transform: "translate(-187.656 -187.658)",
    fill: "#00c4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    d: "M212.657,208.9h0a3.789,3.789,0,0,0-3.783,3.783.511.511,0,0,0,.509.511h0a.51.51,0,0,0,.51-.509,2.769,2.769,0,0,1,2.765-2.764.51.51,0,1,0,0-1.021Z",
    transform: "translate(-202.31 -202.336)",
    fill: "#5f5f5f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGeanderterStatusYellow);
export default __webpack_public_path__ + "static/media/icon_geanderter_status_yellow.b3afd846d46d9dd50e0ca1152562e9fb.svg";
export { ForwardRef as ReactComponent };